import { Box, MenuItem, Select, Typography } from '@mui/material';

export const SortByDropdown = ({
  selectedSortOption,
  setSelectedSortOption
}) => {
  return (
    <Box
      component="span"
      sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}
    >
      <Typography component="span" variant="bodySmall" fontWeight="bold">
        Sort by
      </Typography>
      <Select
        size="small"
        value={selectedSortOption}
        onChange={(e) => setSelectedSortOption(e.target.value)}
        inputProps={{ 'aria-label': 'Sort options' }}
      >
        <MenuItem value="MGC A-Z">MGC A-Z</MenuItem>
        <MenuItem value="MGC Z-A">MGC Z-A</MenuItem>
      </Select>
    </Box>
  );
};
